// eslint-disable-next-line compat/compat
export const MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER || 9007199254740991
